import { CompanySetting } from '@models/settings/company-setting.model';
import { TimeOffBalanceDateSetting } from '@time-off-v3/meta/time-off-meta';

export const isTimeOffBalanceDateToday = async (companyId: number): Promise<boolean> => {
    const [settings] = await CompanySetting.param('company', companyId).with('setting').limit(0).all();

    return settings.find((companySetting: CompanySetting) => companySetting.setting.name === TimeOffBalanceDateSetting)
        .value;
};
